import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/repertoire-agroalimentaire-chaudiere-appalaches_logo.svg'
import _imports_1 from '@/assets/img/icone-checkmark.svg'


const _withScopeId = n => (_pushScopeId("data-v-0c4a7770"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("head", null, [
  /*#__PURE__*/_createElementVNode("title", null, "Inscription | RACA")
], -1))
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "box" }
const _hoisted_4 = {
  id: "section-header",
  class: "main-section"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo Répertoire agroalimentaire Chaudière-Appalaches (RACA)"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Demande d’inscription", -1))
const _hoisted_7 = {
  id: "section-infos-personnelles",
  class: "main-section"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "titre-section" }, "Informations personnelles", -1))
const _hoisted_9 = { class: "inner-section" }
const _hoisted_10 = { class: "input-div" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "input-nom",
  class: "form-label"
}, "Nom", -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { class: "input-div" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "input-prenom",
  class: "form-label"
}, "Prénom", -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { class: "input-div" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "input-email" }, "Adresse courriel", -1))
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = {
  id: "section-infos-entreprise",
  class: "main-section"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "titre-section" }, "Informations sur l'entreprise", -1))
const _hoisted_27 = {
  id: "section-infos-generales",
  class: "inner-section"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Informations générales", -1))
const _hoisted_29 = { class: "input-div" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "input-nomEntreprise" }, "Nom de l'entreprise", -1))
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { key: 2 }
const _hoisted_34 = { class: "input-div" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "input-courrielEntreprise" }, "Adresse courriel de votre entreprise", -1))
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { key: 2 }
const _hoisted_39 = { class: "input-div" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "input-siteWeb" }, [
  /*#__PURE__*/_createTextVNode("Site web "),
  /*#__PURE__*/_createElementVNode("span", { class: "optional" }, "(facultatif)")
], -1))
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "input-div" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Réseaux sociaux "),
  /*#__PURE__*/_createElementVNode("span", { class: "optional" }, "(facultatif)")
], -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Veuillez inscrire l'URL complète.", -1))
const _hoisted_46 = { class: "reseauxSo" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "reseauxSo" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { class: "reseauxSo" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = {
  id: "section-adresse",
  class: "inner-section"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Adresse", -1))
const _hoisted_57 = { class: "input-div" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "adresse" }, "Adresse civique", -1))
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { class: "input-div" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "MRC", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, null, -1))
const _hoisted_64 = ["value"]
const _hoisted_65 = { key: 0 }
const _hoisted_66 = { id: "input-div-flex" }
const _hoisted_67 = {
  id: "input-div-ville",
  class: "input-div"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "input-ville" }, "Ville", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, null, -1))
const _hoisted_70 = ["value"]
const _hoisted_71 = { key: 0 }
const _hoisted_72 = {
  id: "input-div-codePostal",
  class: "input-div"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "input-codePostal" }, "Code postal", -1))
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { key: 1 }
const _hoisted_76 = { key: 2 }
const _hoisted_77 = {
  id: "section-consentement",
  class: "inner-section"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Consentements", -1))
const _hoisted_79 = { class: "input-div" }
const _hoisted_80 = ["onUpdate:modelValue"]
const _hoisted_81 = {
  key: 0,
  class: "errorMessage"
}
const _hoisted_82 = {
  id: "form-end-section",
  class: "inner-section"
}
const _hoisted_83 = {
  key: 0,
  class: "errorMessage"
}
const _hoisted_84 = /*#__PURE__*/_createTextVNode(" Vous avez déjà un compte ? ")
const _hoisted_85 = ["href"]
const _hoisted_86 = {
  id: "popup",
  class: "popup"
}
const _hoisted_87 = { class: "popup-content" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "checkmark"
}, null, -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Inscription complétée", -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Vous recevrez un courriel avec le mot de passe qui a été envoyé à l'adresse courriel fournie. ", -1))
const _hoisted_91 = /*#__PURE__*/_createTextVNode("Retour à l'accueil")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("section", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: '/',
            title: "Page d'accueil RACA",
            class: "flex-gauche"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _hoisted_6
        ]),
        _createElementVNode("section", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("section", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "input-nom",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inscriptionData.nom) = $event))
              }, null, 512), [
                [_vModelText, _ctx.inscriptionData.nom]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.inscriptionData.nom.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "errorMessage",
                  key: error.$uid
                }, [
                  (error.$validator == 'required')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_12, _toDisplayString(_ctx.requiredMessage), 1))
                    : _createCommentVNode("", true),
                  (error.$validator == 'minLength')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_13, " Ce champ doit être au moins " + _toDisplayString(error.$params.min) + " caractères. ", 1))
                    : _createCommentVNode("", true),
                  (error.$validator == 'maxLength')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_14, " Ce champ ne doit pas excéder " + _toDisplayString(error.$params.max) + " caractères. ", 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "input-prenom",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inscriptionData.prenom) = $event))
              }, null, 512), [
                [_vModelText, _ctx.inscriptionData.prenom]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.inscriptionData.prenom.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "errorMessage",
                  key: error.$uid
                }, [
                  (error.$validator == 'required')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_17, _toDisplayString(_ctx.requiredMessage), 1))
                    : _createCommentVNode("", true),
                  (error.$validator == 'minLength')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_18, " Ce champ doit être au moins " + _toDisplayString(error.$params.min) + " caractères. ", 1))
                    : _createCommentVNode("", true),
                  (error.$validator == 'maxLength')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_19, " Ce champ ne doit pas excéder " + _toDisplayString(error.$params.max) + " caractères. ", 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "input-email",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inscriptionData.email) = $event))
              }, null, 512), [
                [_vModelText, _ctx.inscriptionData.email]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.inscriptionData.email.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "errorMessage",
                  key: error.$uid
                }, [
                  (error.$validator == 'required')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_22, _toDisplayString(_ctx.requiredMessage), 1))
                    : _createCommentVNode("", true),
                  (error.$validator == 'email')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_23, " Adresse courriel incorrect "))
                    : _createCommentVNode("", true),
                  (error.$validator == 'maxLength')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_24, " Ce champ ne doit pas excéder " + _toDisplayString(error.$params.max) + " caractères. ", 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("section", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "input-nomEntreprise",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inscriptionData.nomEntreprise) = $event))
              }, null, 512), [
                [_vModelText, _ctx.inscriptionData.nomEntreprise]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.inscriptionData.nomEntreprise.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "errorMessage",
                  key: error.$uid
                }, [
                  (error.$validator == 'required')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_31, _toDisplayString(_ctx.requiredMessage), 1))
                    : _createCommentVNode("", true),
                  (error.$validator == 'minLength')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_32, " Ce champ doit être au moins " + _toDisplayString(error.$params.min) + " caractères. ", 1))
                    : _createCommentVNode("", true),
                  (error.$validator == 'maxLength')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_33, " Ce champ ne doit pas excéder " + _toDisplayString(error.$params.max) + " caractères. ", 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "input-courrielEntreprise",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inscriptionData.emailEntreprise) = $event))
              }, null, 512), [
                [_vModelText, _ctx.inscriptionData.emailEntreprise]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.inscriptionData.emailEntreprise.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "errorMessage",
                  key: error.$uid
                }, [
                  (error.$validator == 'required')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_36, _toDisplayString(_ctx.requiredMessage), 1))
                    : _createCommentVNode("", true),
                  (error.$validator == 'email')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_37, " Adresse courriel incorrect "))
                    : _createCommentVNode("", true),
                  (error.$validator == 'maxLength')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_38, " Ce champ ne doit pas excéder " + _toDisplayString(error.$params.max) + " caractères. ", 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "input-siteWeb",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inscriptionData.siteWeb) = $event))
              }, null, 512), [
                [_vModelText, _ctx.inscriptionData.siteWeb],
                [_directive_maska, _ctx.urlMask]
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.inscriptionData.siteWeb.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "errorMessage",
                key: error.$uid
              }, [
                (error.$validator == 'maxLength')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_41, " Ce champ ne doit pas excéder " + _toDisplayString(error.$params.max) + " caractères. ", 1))
                  : _createCommentVNode("", true),
                (error.$validator == 'url')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_42, _toDisplayString(_ctx.wrongUrlFormat), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, [
                _createVNode(_component_font_awesome_icon, { icon: ['fab', 'facebook'] }),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.inscriptionData.facebook) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.inscriptionData.facebook],
                  [_directive_maska, _ctx.urlMask]
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.inscriptionData.facebook.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "errorMessage",
                  key: error.$uid
                }, [
                  (error.$validator == 'maxLength')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_47, " Ce champ ne doit pas excéder " + _toDisplayString(error.$params.max) + " caractères. ", 1))
                    : _createCommentVNode("", true),
                  (error.$validator == 'url')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_48, _toDisplayString(_ctx.wrongUrlFormat), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_49, [
                _createVNode(_component_font_awesome_icon, { icon: ['fab', 'instagram'] }),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.inscriptionData.instagram) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.inscriptionData.instagram],
                  [_directive_maska, _ctx.urlMask]
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.inscriptionData.instagram.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "errorMessage",
                  key: error.$uid
                }, [
                  (error.$validator == 'maxLength')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_50, " Ce champ ne doit pas excéder " + _toDisplayString(error.$params.max) + " caractères. ", 1))
                    : _createCommentVNode("", true),
                  (error.$validator == 'url')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_51, _toDisplayString(_ctx.wrongUrlFormat), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_52, [
                _createVNode(_component_font_awesome_icon, { icon: ['fab', 'twitter'] }),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.inscriptionData.twitter) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.inscriptionData.twitter],
                  [_directive_maska, _ctx.urlMask]
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.inscriptionData.twitter.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "errorMessage",
                  key: error.$uid
                }, [
                  (error.$validator == 'maxLength')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_53, " Ce champ ne doit pas excéder " + _toDisplayString(error.$params.max) + " caractères. ", 1))
                    : _createCommentVNode("", true),
                  (error.$validator == 'url')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_54, _toDisplayString(_ctx.wrongUrlFormat), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("section", _hoisted_55, [
            _hoisted_56,
            _createElementVNode("div", _hoisted_57, [
              _hoisted_58,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "adresse",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.inscriptionData.adresseProd) = $event))
              }, null, 512), [
                [_vModelText, _ctx.inscriptionData.adresseProd]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.inscriptionData.adresseProd.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "errorMessage",
                  key: error.$uid
                }, [
                  (error.$validator == 'required')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_59, _toDisplayString(_ctx.requiredMessage), 1))
                    : _createCommentVNode("", true),
                  (error.$validator == 'maxLength')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_60, " Ce champ ne doit pas excéder " + _toDisplayString(error.$params.max) + " caractères. ", 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_61, [
              _hoisted_62,
              _withDirectives(_createElementVNode("select", {
                onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.inscriptionData.mrc_id) = $event))
              }, [
                _hoisted_63,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mrcs, (mrc) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: mrc.id,
                    value: mrc.id
                  }, _toDisplayString(mrc.nom), 9, _hoisted_64))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.inscriptionData.mrc_id]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.inscriptionData.mrc_id.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "errorMessage",
                  key: error.$uid
                }, [
                  (error.$validator == 'required')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_65, _toDisplayString(_ctx.requiredMessage), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("div", _hoisted_67, [
                _hoisted_68,
                _withDirectives(_createElementVNode("select", {
                  id: "input-ville",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.inscriptionData.ville_id) = $event))
                }, [
                  _hoisted_69,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.villesMrc, (ville) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: ville.id,
                      value: ville.id
                    }, _toDisplayString(ville.nom), 9, _hoisted_70))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.inscriptionData.ville_id]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.inscriptionData.ville_id.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "errorMessage",
                    key: error.$uid
                  }, [
                    (error.$validator == 'required')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_71, _toDisplayString(_ctx.requiredMessage), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_72, [
                _hoisted_73,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "input-codePostal",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.inscriptionData.codePostal) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.inscriptionData.codePostal],
                  [_directive_maska, 'A#A #A#']
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.inscriptionData.codePostal.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "errorMessage",
                    key: error.$uid
                  }, [
                    (error.$validator == 'required')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_74, _toDisplayString(_ctx.requiredMessage), 1))
                      : _createCommentVNode("", true),
                    (error.$validator == 'maxLength')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_75, " Ce champ ne doit pas excéder " + _toDisplayString(error.$params.max) + " caractères. ", 1))
                      : _createCommentVNode("", true),
                    (error.$validator == 'codePostal')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_76, _toDisplayString(_ctx.wrongFormat), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_77, [
            _hoisted_78,
            _createElementVNode("div", _hoisted_79, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.consentements, (consentement) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "consentement",
                  key: consentement.id
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": ($event: any) => ((consentement.selected) = $event)
                  }, null, 8, _hoisted_80), [
                    [_vModelCheckbox, consentement.selected]
                  ]),
                  _createElementVNode("p", null, _toDisplayString(consentement.nom), 1)
                ]))
              }), 128)),
              (_ctx.errorCheckboxes)
                ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.requiredMessageCheckbox), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("section", _hoisted_82, [
            _createElementVNode("button", {
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.submitform && _ctx.submitform(...args)))
            }, "Envoyer la demande"),
            (_ctx.serverError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_83, _toDisplayString(_ctx.serverMessage), 1))
              : _createCommentVNode("", true),
            _createElementVNode("p", null, [
              _hoisted_84,
              _createElementVNode("a", {
                href: _ctx.loginLink(),
                title: "Lien de connexion"
              }, "Connectez-vous", 8, _hoisted_85)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_86, [
        _createElementVNode("div", _hoisted_87, [
          _hoisted_88,
          _hoisted_89,
          _hoisted_90,
          _createVNode(_component_router_link, {
            to: '/',
            title: "Page d'accueil RACA"
          }, {
            default: _withCtx(() => [
              _hoisted_91
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
}